/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
